import { render, staticRenderFns } from "./ClippingImage.vue?vue&type=template&id=5c3907a0&scoped=true&"
import script from "./ClippingImage.vue?vue&type=script&lang=js&"
export * from "./ClippingImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3907a0",
  null
  
)

export default component.exports